import React from "react";
import "./intro.css";
import bg from "../../assets/hero1.png";

const Intro = () => {
  return (
    <section id="intro">

      {/* Row 1 */}
      <div className="row1">
        <h1 className="introtext">
          Order Food, Groceries, and Book Rides - All in One App!
        </h1>
      </div>

      {/* Row 2 */}
      <div className="row2">
        <div className="introcontent">
          <p className="intropara">
            Miogra brings everything you need to your fingertips,
            with lightning-fast delivery, secure payments, and a smooth
            experience.
          </p>

          <div className="buttons">
            <a
              href="https://play.google.com/store/apps/details?id=com.gobbogtechnologies.miograuser&hl=en_IN"
              target="_blank"
              rel="noopener noreferrer"
              className="introbtn2"
            >
              Get it on Play Store
            </a>
          </div>
        </div>

        <img src={bg} alt="app preview" className="introimg" />
      </div>
    </section>
  );
};

export default Intro;
